import type { Event } from '@cocoonspace/sdk-js/types/event'

import { isLastMinuteBooking } from './is-last-minute-booking'

export const shouldAddWallet = ({
	isBusiness,
	events,
	defaultRefundModeIsWallet,
	walletAmount,
}: {
	isBusiness: boolean
	events: Event[]
	defaultRefundModeIsWallet: boolean
	walletAmount?: number
}) => {
	if (isBusiness) return false
	// if (!hasWalletRefundOnBooking && events.length > 1) return false
	if (walletAmount && walletAmount > 0) return true
	if (isLastMinuteBooking(events)) return false

	return defaultRefundModeIsWallet
}
